import { apiFetch } from "./apiClient";
import type { AuditFields } from "./audit";

/** Maps to the backend's AmenityDto — the real, live Amenities resource. */
export interface AmenityDto extends AuditFields {
  amenityId: number;
  accountId: number;
  branchId: number | null;
  /** The branches the amenity is offered at; empty = every branch. Absent
   * from an older API. */
  branchIds?: number[];
  amenityName: string | null;
  description: string | null;
  amenityType: string | null;
  isActive: boolean;
}

export interface AmenityPayload {
  accountId: number;
  /** Legacy single branch — the one branch when exactly one is picked. */
  branchId: number | null;
  /** The branches to offer the amenity at; empty = every branch. */
  branchIds: number[];
  amenityName: string | null;
  description: string | null;
  amenityType: string | null;
  isActive: boolean;
}

export const listAmenities = async (): Promise<AmenityDto[]> => {
  const res = await apiFetch("/amenities");
  return res.json();
};

export const createAmenity = async (
  payload: AmenityPayload
): Promise<AmenityDto> => {
  const res = await apiFetch("/amenities", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateAmenity = async (
  amenityId: number,
  payload: AmenityPayload
): Promise<void> => {
  await apiFetch(`/amenities/${amenityId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

export const deleteAmenity = async (amenityId: number): Promise<void> => {
  await apiFetch(`/amenities/${amenityId}`, { method: "DELETE" });
};
